var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUploadFileActive = function SvgUploadFileActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#1C7CE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.647 54.352h8.47v-8.47h5.647L47.882 36 38 45.883h5.647v8.47ZM38 57.176h19.764V60H38v-2.824Z",
    fill: "#ECECE7"
  })));
};
export default SvgUploadFileActive;